// Brand mark: speech bubble with check, inline SVG, no image assets.
// Light surfaces: bubble var(--navy-950), check var(--brand).
// Dark surfaces (dark prop): bubble var(--paper), check var(--brand).

export const BrandMark = ({ size = 32, dark = false }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M16.5 2.5C9.6 2.5 4 8.05 4 14.9c0 3.2 1.23 6.12 3.25 8.32-.34 1.62-1.1 3.5-2.47 4.98-.4.43-.1 1.15.48 1.12 2.6-.12 4.9-1.03 6.6-2.06 1.44.53 3 .82 4.64.82 6.9 0 12.5-5.55 12.5-12.4S23.4 2.5 16.5 2.5Z"
      fill={dark ? "var(--paper)" : "var(--navy-950)"}
    />
    <path
      d="M11 15.5l3.5 3.5L22 11"
      stroke="var(--brand)"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export const BrandWordmark = ({ dark = false, className = "" }) => (
  <span className={`font-heading font-semibold ${dark ? "text-[var(--paper)]" : "text-foreground"} ${className}`}>
    EnquiryOps
  </span>
);
